<div class="create-proposal-scope-service-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>handyman</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Service Name</h2>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="row m-auto popup-body popup-convert-wrapper align-items-center" [formGroup]="proposalScopeServiceForm">

    <div class="col-md-6 mt-2">
      <div class="form-group col-12">
        <label for="name" class="custom_label"> Name *</label>
        <input type="text" #htmlInputElement id="name" formControlName="name" class="form-control" placeholder="Service Name" name="name">
        <app-validation-error [formGroup]="proposalScopeServiceForm" [controlName]="'name'"></app-validation-error>
      </div>
    </div>

    <!--<div class="col-md-6 mt-2">
      <label  class="custom_label"> scopes *</label>
      <ng-select
        id="scopes"
        [multiple]="true"
        [items]="scopes"
        placeholder="Select Scopes"
        [closeOnSelect]="true"
        formControlName="scopes"
        bindLabel="name"
      >
      </ng-select>
      <app-validation-error [formGroup]="proposalScopeServiceForm" [controlName]="'scopes'"></app-validation-error>
    </div>-->


    <div class="col-md-6 mt-2">
      <label  class="custom_label"> Service Type *</label>
      <ng-select
        id="serviceType"
        [items]="serviceService.serviceTypes"
        placeholder="Select service type"
        [closeOnSelect]="true"
        formControlName="serviceType"
        bindLabel="name"
        [readonly]="ngSelectReadOnly"
      >
      </ng-select>
      <app-validation-error [formGroup]="proposalScopeServiceForm" [controlName]="'serviceType'"></app-validation-error>
    </div>

    <div class="col-md-6 mt-2">
      <label  class="custom_label"> Subcontractor *</label>
      <div class="d-flex">
        <ng-select
          class="col-11"
          [items]="serviceService.subcontractors"
          placeholder="Select subcontractors"
          [closeOnSelect]="true"
          formControlName="subcontractor"
          bindLabel="name"
          style="height: 60px"
        >
        </ng-select>
        <button type="button" (click)="createQuickSubcontractor()" class="btn_add_more_sm add_contractor_btn">+</button>
      </div>
      <app-validation-error [formGroup]="proposalScopeServiceForm" [controlName]="'subcontractor'"></app-validation-error>
    </div>



    <div class="col-md-6 mt-2">
      <label for="productUrl">Unit Price*</label>
      <div class=" input-boxs input_with_icons">
      <span class="icon_wraps"><img src="../../../../assets/img/dollar_sign.svg" alt="icon"></span>
      <input currencyMask [max]="99999999.99" [options]="currencyMaskOptions"   name="productUrl" formControlName="unitPrice" class="form-control"
             placeholder="Type here" autocomplete="off">

      </div>
      <app-validation-error [formGroup]="proposalScopeServiceForm" [controlName]="'unitPrice'"></app-validation-error>
    </div>





    <div class="col-md-6 mt-2">
      <label for="markUp" class="custom_label"> Mark Up *</label>
      <div class=" input-boxs input_with_icons">
        <span class="icon_wraps">%</span>
      <input currencyMask [max]="99999999.99" [options]="currencyMaskOptions"   id="markUp" formControlName="mark_up" class="form-control"
             placeholder="Type here" autocomplete="off">
        </div>
      <app-validation-error [formGroup]="proposalScopeServiceForm" [controlName]="'mark_up'"></app-validation-error>
    </div>



    <div class="col-md-12 mt-2">
      <label for="description">Description</label>
      <textarea name="description" id="description" formControlName="description" rows="4"
                placeholder="Type here"></textarea>
               <app-validation-error [formGroup]="proposalScopeServiceForm" [controlName]="'description'"></app-validation-error>
    </div>


  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-submit" (click)="save()">
      <mat-icon>check_circle</mat-icon>
      Save
    </button>
  </div>
</div>

